<template>
    <div class="row">
        <div class="col-12">
            <div class="table-responsive">
                <table class="table table-sm" aria-describedby="executive-information">
                    <tbody>
                        <tr>
                            <td>CEO</td>
                            <td>{{ executiveInformation.ceo|placeholder }}</td>
                        </tr>
                        <tr>
                            <td>Secretary</td>
                            <td>{{ executiveInformation.secretary|placeholder }}</td>
                        </tr>
						<tr>
							<td colspan="2">Account Signatories</td>
						</tr>
						<tr v-for="(signatory, index) in account_signatories" :key="'as-' + index">
							<td>{{ index + 1 }} . {{ signatory.name }}</td>
							<td><a href="#" @click.prevent="showSignatoryDetails(signatory)" class="ml-3">View</a></td>
						</tr>
                    </tbody>
                </table>
            </div>
        </div>

        <view-attached-institution-user-modal-component :modal-id="modalId" :title="modalTitle" :user="currentAttachedInstitutionUser" ></view-attached-institution-user-modal-component>
    </div>
</template>


<script>
	export default {
		data() {
			const {
				account_signatories: accountSignatories,
				executive_information: executiveInformation,
			} = this.company;

            console.log(this.company);

			return {
                modalId: 'view-board-of-director-modal',
                modalTitle: '',
				accountSignatories,
				executiveInformation,
                currentAttachedInstitutionUser: {},
			};
		},
        methods:{
            showSignatoryDetails(signatory){
                this.currentAttachedInstitutionUser = signatory;
                this.modalTitle = `${signatory.name} - Account Signatory`
                $('#' + this.modalId).modal('show');
            },
            showDirectorDetails(director){
                this.currentAttachedInstitutionUser = director;
                this.modalTitle = `${director.name} - Board of Director`
                $('#' + this.modalId).modal('show');
            }
        },
		props: ["company"],
	};
</script>
